<script setup>
import { inject, onMounted, onUnmounted, ref, watch, computed } from 'vue';
import MapLibreGL from 'maplibre-gl';

const props = defineProps({
  className: {
    type: String,
    default: '',
  },
  options: {
    type: Object,
    default: () => ({}),
  },
});

const { marker } = inject('markerContext', { marker: ref(null) });
const { map } = inject('mapContext');

const popupInstance = ref(null);
const containerRef = ref(null);

onMounted(() => {
  if (!map.value) return;

  const container = document.createElement('div');
  container.className = `custom-mapcn-popup ${props.className}`;
  containerRef.value = container;

  const popup = new MapLibreGL.Popup({
    offset: 16,
    closeButton: false,
    ...props.options,
  })
    .setMaxWidth('none')
    .setDOMContent(container);

  if (marker.value) {
    marker.value.setPopup(popup);
  } else {
    // If not used inside a marker, we'd need coordinates, but usually it is.
  }

  popupInstance.value = popup;
});

onUnmounted(() => {
  if (popupInstance.value) {
    popupInstance.value.remove();
    popupInstance.value = null;
  }
});

const isReady = computed(() => !!containerRef.value);
</script>

<template>
  <div v-if="isReady">
    <Teleport :to="containerRef">
      <div
        class="p-3 bg-n-background border border-n-weak rounded-xl shadow-xl animate-in fade-in-0 zoom-in-95"
      >
        <slot />
      </div>
    </Teleport>
  </div>
</template>
